import React from "react";

import {
  JOBCASTS,
  CANDIDATES,
  AGENCIES,
} from "../../../shared/Search/constants";
import {
  deconstructName,
  deconstructDescription,
} from "../../../shared/Search/utils";

const renderTitleCaption = (item, JOBCASTS) => {
  const styles = {
    infoContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      width: "calc(100% - 140px)",
      minWidth: 120,
      paddingLeft: JOBCASTS ? 12 : 24,
    },
    ellipsisOverflow: {
      maxWidth: "100%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  };

  return (
    <div style={styles.infoContainer}>
      <h5 style={styles.ellipsisOverflow}>
        {Object.values(deconstructName(item)).join(" ")}
      </h5>
      <span className="subtitle-1" style={styles.ellipsisOverflow}>
        {deconstructDescription(item)}
      </span>
      {item.type === JOBCASTS && item.isRecruiter && (
      <span className="subtitle-1" style={styles.ellipsisOverflow}>
        JobCast ID:
        {' '}
        {item.jobcastIdentifier}
      </span>
      )}
    </div>
  );
};

function SearchResultItemBody({ item }) {
  switch (item.type) {
    case CANDIDATES:
    case AGENCIES:
      return renderTitleCaption(item);
    case JOBCASTS:
      return renderTitleCaption(item, JOBCASTS);
    default:
      return <></>;
  }
}

export default SearchResultItemBody;
